<template>
  <button class="apply-bulk-order-button" @click="onClick">
    <span class="apply-bulk-order-button__text subhead-bold">
      <span>今すぐ</span>
      <span>申し込む</span>
    </span>
  </button>
</template>

<script setup>
const emit = defineEmits(['click-button'])

const onClick = () => {
  emit('click-button')
}
</script>

<style lang="scss" scoped>
.apply-bulk-order-button {
  @extend %hover-common;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 108px;
  border-radius: 50%;
  background-color: $primary;
  cursor: pointer;

  @media all and (max-width: ($base-contents-width  - 1)) {
    width: 65px;
    height: 65px;
  }

  &__text {
    font-size: 1.6rem;
    line-height: 1;
    color: $white;
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media all and (max-width: ($base-contents-width  - 1)) {
      font-size: 1.2rem;
    }
  }
}
</style>
